export default "__VITE_ASSET__B_f$23pS__"